module.exports = __webpack_public_path__ + "img/aviator-22.655ac5f5.jpg";